import TEMPLATE_URL from "emun.cart/cart-list-advanced.htm";
import controller from "emun.cart/cart-list-advanced.controller";
import open from "webmodals/open";

export default ({
  size = "xl",
  backdrop = "static",
  placement = "center",
  templateUrl = TEMPLATE_URL,
  title = `Cart Advanced View`,
  subTitle,
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      subTitle: () => subTitle,
    },
  }).result;
